import clients from './clients';

export default function*() {
    yield* [...clients];
}
